$(function () {
  if (!customElements.get('menu-mobile-list')) {
    customElements.define(
      'menu-mobile-list',
      class menuMobileList extends HTMLElement {
        constructor() {
          super();
          this.$mobileToolbarList = null;
          this.$listItems = null;
          this.$mobileToolbarItem = null;
          this.$plan2SwiperList = null;
          this.$plan3Swiper = null;
          this.$plan1MenuItemName = null;
          this.$popupContainer = null;
          this.$navLaunchMainCenterNavList = null;
          this.$popupContainerMainListTag = null;
          this.$activeNavList = [];
          this.$mobileProductList = [];
          this.$childItemDataIndex = 0;
          this.$navHeader = null;
          this.$body = null;
        }
        connectedCallback() {
          // 点击展开移动端导航菜单列表
          this.$mobileToolbarList = this.querySelector('.mobile-toolbar-list');
          this.$mobileToolbarItem = this.$mobileToolbarList.querySelectorAll('.mobile-toolbar-item');
          this.$listItems = this.querySelectorAll('.icon-dropdown-series-item');
          this.$plan2SwiperList = this.querySelectorAll('.plan2Swiper');
          this.$plan3Swiper = this.querySelectorAll('.plan3SwiperMobile');
          this.$body = $('body');
          this.init();
          this.swiperFuntion();
        }

        init() {
          // 展开列表数据
          this.$mobileToolbarItem.forEach((item) => {
            customEventListener(item, 'click', (event) => {
              // 获取当前点击的元素
              const currentItem = event.currentTarget;
              // 获取当前点击元素的 data-target 属性
              this.currentTarget = currentItem.getAttribute('data-target');
              console.log(this.currentTarget, 'currentTarget');

              const dropdown = item.nextElementSibling;
              // 点击导航-> li 有多级或者直接展示在当前弹窗的样式
              if (dropdown && dropdown.classList.contains('icon-dropdown-series-item')) {
                const iconDropdown = item.querySelector('.icon-dropdown');
                iconDropdown.classList.toggle('rotate-effect');
                this.$mobileToolbarItem.forEach((item) => {
                  const otherDropdown = item.nextElementSibling;
                  if (otherDropdown && otherDropdown !== dropdown) {
                    // 如果classList包含show，则移除
                    if (otherDropdown && otherDropdown.classList.contains('show')) {
                      otherDropdown.classList.remove('show');
                    }

                    item.querySelector('.icon-dropdown').classList.remove('rotate-effect');
                  }
                  if (item.getAttribute('data-target') == 'menu-plan-5') {
                    const menuItemsLi = otherDropdown.querySelectorAll('.icon-dropdown-series-item-li');
                    menuItemsLi.forEach((childItem) => {
                      // 将三级菜单的子项关闭
                      if (iconDropdown && !iconDropdown.classList.contains('rotate-effect')) {
                        childItem.querySelector('.icon-dropdown').classList.remove('rotate-effect');
                        const subItem = otherDropdown.querySelectorAll('.icon-dropdown-series-sub-item');
                        subItem.forEach((res) => {
                          if (res.classList.contains('subItemOpen')) {
                            res.classList.remove('subItemOpen');
                          }
                        });
                      }
                      customEventListener(childItem, 'click', () => {
                        const targetClass = Array.from(childItem.classList).find((cls) => cls.startsWith('target-'));
                        const iconDropdown = childItem.querySelector('.icon-dropdown');
                        iconDropdown.classList.toggle('rotate-effect');
                        // 查找对应的 sub-item 元素
                        const subItem = otherDropdown.querySelector(`.icon-dropdown-series-sub-item.${targetClass}`);
                        // 隐藏所有的 sub-items
                        otherDropdown.querySelectorAll('.icon-dropdown-series-sub-item').forEach((sub) => {
                          // 如果 sub 不是当前的 subItem，将其隐藏
                          if (sub !== subItem) {
                            sub.classList.remove('subItemOpen');
                            sub.classList.add('subItemClose');
                          }
                        });
                        // 切换当前子菜单的显示状态
                        if (subItem.classList.contains('subItemOpen')) {
                          // 如果当前 sub-item 已显示，则隐藏它
                          subItem.classList.remove('subItemOpen');
                          subItem.classList.add('subItemClose');
                        } else {
                          // 否则，显示当前 sub-item
                          subItem.classList.remove('subItemClose');
                          subItem.classList.add('subItemOpen');
                        }
                      });
                    });
                  }

                  if (item.getAttribute('data-target') == 'menu-plan-1') {
                    this.$navHeader = $('.nav-header')[0];
                    const menuItemsLi = otherDropdown.querySelectorAll('.icon-dropdown-series-item-li');
                    menuItemsLi.forEach((childItem) => {
                      customEventListener(childItem, 'click', () => {
                        const childItemDataIndex = childItem.getAttribute('data-index');
                        this.$childItemDataIndex = childItem.getAttribute('data-index');
                        this.$navHeader.style.display = 'none';

                        // 导航点击二次弹窗的样式
                        const navLaunch = otherDropdown.querySelector('.mobile-starry-nav-launch');
                        navLaunch.style.display = 'block';

                        // 处理二级弹窗的标题
                        this.plan1MenuItemName = childItem.querySelector('span').innerText;
                        const secondaryContainer = navLaunch.querySelector('.starry-secondary-container');
                        const navLeft = secondaryContainer.querySelector('.starry-nav-m-left');
                        const navMcenter = secondaryContainer.querySelector('.starry-nav-m-center');
                        navMcenter.innerText = this.plan1MenuItemName;
                        customEventListener(navLeft, 'click', () => {
                          navLaunch.style.display = '';
                          this.$navHeader.style.display = '';
                        });
                        //处理二级弹窗end
                        // 筛选对比
                        const crumbsContainer = navLaunch.querySelector('.mobile-crumbs-container');
                        const compareList = crumbsContainer.querySelectorAll('.compare-list');
                        compareList.forEach((res) => {
                          const navListDataIndex = res.getAttribute('data-index');
                          if (childItemDataIndex === navListDataIndex) {
                            res.classList.add('flex');
                            res.classList.remove('hidden');
                          } else {
                            res.classList.remove('flex');
                            res.classList.add('hidden');
                          }
                        });
                        // 筛选Tab start
                        const navLaunchPosition = navLaunch.querySelector(
                          '.mobile-starry-nav-launch-main-center-position'
                        );
                        const chooseListElement = navLaunchPosition.querySelector('.chooseList');
                        chooseListElement.classList.remove('hidden');
                        chooseListElement.classList.add('flex');
                        const navList = chooseListElement.querySelectorAll(
                          '.mobile-starry-nav-launch-main-center-nav-list'
                        );

                        let PopupButton = navLaunch.querySelector('.PopupButton');
                        this.$overlay = navLaunch.querySelector('.overlay');
                        this.$popupContainer = navLaunch.querySelector('.starry-popup-container');

                        customEventListener(PopupButton, 'click', () => {
                          this.$popupContainer.classList.add('block');
                          this.$overlay.style.display = 'block';
                          this.$popupContainer.classList.remove('hidden');
                          // 处理移动端右侧弹窗逻辑
                          const popupChooseContainer = this.$popupContainer.querySelector('.popup-choose-container');
                          const containerMainList = popupChooseContainer.querySelectorAll(
                            '.starry-popup-container-main-list'
                          );

                          if (containerMainList && containerMainList.length > 0) {
                            containerMainList.forEach((res) => {
                              const containerMainListDataIndex = res.getAttribute('data-index');
                              if (this.$childItemDataIndex == containerMainListDataIndex) {
                                res.classList.remove('hidden');
                                res.classList.add('block');

                                this.$popupContainerMainListTag = res.querySelectorAll(
                                  '.starry-popup-container-main-item'
                                );
                                this.$popupContainerMainListTag.forEach((childRes) => {
                                  const spanContent = childRes.querySelector('span')?.innerHTML;

                                  if (spanContent && this.$activeNavList.includes(spanContent)) {
                                    childRes.classList.add('nav-active');
                                  }
                                  customEventListener(childRes, 'click', () => {
                                    childRes.classList.toggle('nav-active');
                                    // 更新 activeNavList
                                    if (childRes.classList.contains('nav-active')) {
                                      // 添加到 activeNavList
                                      if (!this.$activeNavList.includes(spanContent)) {
                                        this.$activeNavList.push(spanContent);
                                      }
                                    } else {
                                      // 从 activeNavList 移除
                                      const index = this.$activeNavList.indexOf(spanContent);
                                      if (index > -1) {
                                        this.$activeNavList.splice(index, 1);
                                      }
                                    }
                                  });
                                });
                              } else {
                                res.classList.remove('block');
                                res.classList.add('hidden');
                              }
                            });
                          }
                          //  右侧弹窗逻辑end
                        });
                        const formConfirmButton = this.$popupContainer.querySelector('.formConfirmButton');
                        const formClearButton = this.$popupContainer.querySelector('.formClearButton');
                        customEventListener(this.$overlay, 'click', () => {
                          this.$overlay.style.display = '';
                          this.$popupContainer.classList.add('hidden');
                          this.$popupContainer.classList.remove('block');
                        });
                        // 弹窗OK确认事件
                        customEventListener(formConfirmButton, 'click', () => {
                          this.$popupContainer.classList.add('hidden');
                          this.$popupContainer.classList.remove('block');
                          this.$overlay.style.display = '';
                          if (this.$navLaunchMainCenterNavList) {
                            this.$navLaunchMainCenterNavList.forEach((navLaunchMainCenterNavItem) => {
                              const spanContent = navLaunchMainCenterNavItem.querySelector('span')?.innerHTML;

                              if (spanContent && this.$activeNavList.includes(spanContent)) {
                                navLaunchMainCenterNavItem.classList.add('nav-active');
                              } else {
                                navLaunchMainCenterNavItem.classList.remove('nav-active');
                              }
                            });
                          }
                          this.filterProductFunction();
                        });
                        // 弹窗Clear清空事件
                        customEventListener(formClearButton, 'click', () => {
                          this.$popupContainer.classList.add('hidden');
                          this.$popupContainer.classList.remove('block');
                          this.$overlay.style.display = '';
                          this.$activeNavList = [];
                          if (this.$navLaunchMainCenterNavList) {
                            this.$navLaunchMainCenterNavList.forEach((item) => {
                              item.classList.remove('nav-active');
                            });
                          }
                          if (this.$popupContainerMainListTag) {
                            this.$popupContainerMainListTag.forEach((item) => {
                              item.classList.remove('nav-active');
                            });
                          }
                          this.filterProductFunction();
                        });
                        navList.forEach((res) => {
                          const navListDataIndex = res.getAttribute('data-index');
                          if (childItemDataIndex === navListDataIndex) {
                            const liLength = res.querySelectorAll('li').length;
                            if (liLength <= 0) {
                              //将 chooseList 隐藏
                              const chooseList = navLaunch.querySelector('.chooseList');
                              chooseList.classList.add('hidden');
                            } else {
                              //将 chooseList 显示
                              const chooseList = navLaunch.querySelector('.chooseList');
                              chooseList.classList.remove('hidden');
                            }
                            res.classList.add('flex');
                            res.classList.remove('hidden');
                            this.$navLaunchMainCenterNavList = res.querySelectorAll(
                              '.mobile-starry-nav-launch-main-center-nav-item'
                            );
                            this.$navLaunchMainCenterNavList.forEach((navLaunchMainCenterNavItem) => {
                              customEventListener(navLaunchMainCenterNavItem, 'click', () => {
                                let activeItemInnerHTML = navLaunchMainCenterNavItem.querySelector('span').innerHTML;
                                navLaunchMainCenterNavItem.classList.toggle('nav-active');
                                if (navLaunchMainCenterNavItem.classList.contains('nav-active')) {
                                  this.$activeNavList.push(activeItemInnerHTML);
                                } else {
                                  this.$activeNavList = this.$activeNavList.filter(
                                    (item) => item !== activeItemInnerHTML
                                  );
                                }
                                // 假设 this.$activeNavList 和 this.$mobileProductList 是你已经定义好的 DOM 列表

                                this.filterProductFunction();
                              });
                            });
                          } else {
                            res.classList.remove('flex');
                            res.classList.add('hidden');
                          }
                        });
                        // 筛选Tab end
                        const menuPlan1ProductList = navLaunch.querySelector('.menu-plan-1-product-list');
                        const menuPlan1Expand = menuPlan1ProductList.querySelector('.menu-plan-1-expand');
                        const navLaunchMainCenterList = menuPlan1Expand.querySelectorAll(
                          '.mobile-starry-nav-launch-main-center-list'
                        );
                        navLaunchMainCenterList.forEach((res) => {
                          const navLaunchMainCenterResDataIndex = res.getAttribute('data-index');
                          if (childItemDataIndex === navLaunchMainCenterResDataIndex) {
                            this.$mobileProductList = res.querySelectorAll(
                              '.mobile-starry-nav-launch-main-center-item'
                            );

                            res.classList.add('flex');
                            res.classList.remove('hidden');
                          } else {
                            res.classList.remove('flex');
                            res.classList.add('hidden');
                          }
                        });
                      });
                    });
                  } else if (item.getAttribute('data-target') == 'menu-plan-2') {
                    const navLaunch = otherDropdown.querySelector('.mobile-starry-nav-launch');
                    const secondaryContainer = navLaunch.querySelector('.starry-secondary-container');
                    const navLeft = secondaryContainer.querySelector('.starry-nav-m-left');
                    const navMcenter = secondaryContainer.querySelector('.starry-nav-m-center');
                    const childItemName = item.querySelector('span')?.innerHTML;
                    navMcenter.innerText = childItemName;

                    if (window.innerWidth <= 576) {
                      if (this.currentTarget == 'menu-plan-2') {
                        navLaunch.style.display = 'block';
                        setTimeout(() => {
                          this.$navHeader.style.display = 'none';
                        }, 50);
                      }

                      // 点击事件
                      customEventListener(navLeft, 'click', () => {
                        navLaunch.style.display = '';
                        this.$navHeader.style.display = '';
                        this.$mobileToolbarItem.forEach((item) => {
                          const otherDropdown = item.nextElementSibling;
                          if (otherDropdown && otherDropdown.classList.contains('show')) {
                            otherDropdown.classList.remove('show');
                          }
                          item.querySelector('.icon-dropdown').classList.remove('rotate-effect');
                        });
                      });
                      // 定义 resize 事件处理逻辑
                      const resizeHandler = () => {
                        this.$mobileToolbarItem.forEach((item) => {
                          const otherDropdown = item.nextElementSibling;
                          if (otherDropdown && otherDropdown.classList.contains('show')) {
                            otherDropdown.classList.remove('show');
                          }
                          item.querySelector('.icon-dropdown').classList.remove('rotate-effect');
                        });

                        if (window.innerWidth > 576) {
                          navLaunch.style.display = 'none';
                          // 移除 resize 监听器
                          window.removeEventListener('resize', resizeHandler);
                        }
                      };

                      // 添加 resize 监听
                      customEventListener(window, 'resize', resizeHandler);
                    }
                  } else if (item.getAttribute('data-target') === 'menu-plan-4') {
                    const navLaunch = otherDropdown.querySelector('.mobile-starry-nav-launch');
                    const secondaryContainer = navLaunch.querySelector('.starry-secondary-container');
                    const navLeft = secondaryContainer.querySelector('.starry-nav-m-left');
                    const navMcenter = secondaryContainer.querySelector('.starry-nav-m-center');
                    const childItemName = item.querySelector('span')?.innerHTML;

                    navMcenter.innerText = childItemName;

                    if (window.innerWidth <= 576) {
                      if (this.currentTarget == 'menu-plan-4') {
                        navLaunch.style.display = 'block';
                        setTimeout(() => {
                          this.$navHeader.style.display = 'none';
                        }, 50);
                      }

                      requestAnimationFrame(() => {
                        // 确保 navLaunch 已经显示
                      });
                      customEventListener(navLeft, 'click', () => {
                        navLaunch.style.display = '';
                        this.$navHeader.style.display = '';
                        this.$mobileToolbarItem.forEach((item) => {
                          const otherDropdown = item.nextElementSibling;
                          if (otherDropdown && otherDropdown.classList.contains('show')) {
                            otherDropdown.classList.remove('show');
                          }
                          item.querySelector('.icon-dropdown').classList.remove('rotate-effect');
                        });
                      });
                      // 定义 resize 事件处理逻辑
                      const resizeHandler = () => {
                        this.$mobileToolbarItem.forEach((item) => {
                          const otherDropdown = item.nextElementSibling;
                          if (otherDropdown && otherDropdown.classList.contains('show')) {
                            otherDropdown.classList.remove('show');
                          }
                          item.querySelector('.icon-dropdown').classList.remove('rotate-effect');
                        });

                        if (window.innerWidth > 576) {
                          navLaunch.style.display = 'none';
                          // 移除 resize 监听器
                          window.removeEventListener('resize', resizeHandler);
                        }
                      };

                      // 添加一次性 resize 监听器
                      window.addEventListener('resize', resizeHandler);
                    }
                  }
                });

                // 展开或收起当前点击的菜单
                dropdown.classList.toggle('show');
              } else {
              }
            });
          });
        }
        filterProductFunction() {
          if (this.$mobileProductList && this.$mobileProductList.length > 0) {
            this.$mobileProductList.forEach((mobileItem) => {
              // 如果 activeNavList 为空，直接显示所有 items
              if (!this.$activeNavList || this.$activeNavList.length === 0) {
                mobileItem.style.display = 'flex';
                return;
              }

              // 获取 data-target 属性值并分割
              let dataTarget = mobileItem.getAttribute('data-target');

              if (dataTarget && dataTarget.trim() !== '') {
                let targetsArray = dataTarget.split(',').map((tag) => tag.trim());

                // 判断 activeNavList 是否完全包含于 targetsArray
                let isMatch = this.$activeNavList.every((activeItem) => targetsArray.includes(activeItem));

                // 根据 isMatch 结果设置样式
                if (isMatch) {
                  mobileItem.style.display = 'flex'; // 显示
                } else {
                  mobileItem.style.display = 'none'; // 隐藏
                }
              } else {
                // dataTarget 为空或无效，直接隐藏
                mobileItem.style.display = 'none';
              }
            });
          }
        }
        swiperFuntion() {
          // 执行场景swiper
          this.$plan2SwiperList.forEach((item, index) => {
            new Swiper(item, {
              slidesPerView: 5,
              spaceBetween: 21,
              freeMode: false,
              cssMode: true,
              breakpoints: {
                1100: {
                  slidesPerView: 5,
                },
                992: {
                  slidesPerView: 4,
                },
                768: {
                  slidesPerView: 3,
                },
                576: {
                  slidesPerView: 2,
                },

                370: {
                  slidesPerView: 2,
                },
              },
            });
          });

          this.$plan3Swiper.forEach((res) => {
            new Swiper(res, {
              slidesPerView: 5,
              spaceBetween: 21,
              freeMode: true,
              cssMode: true,
              breakpoints: {
                1400: {
                  slidesPerView: 5,
                },
                1100: {
                  slidesPerView: 5,
                },
                992: {
                  slidesPerView: 4,
                },
                768: {
                  slidesPerView: 3,
                },
                576: {
                  slidesPerView: 2,
                },

                370: {
                  slidesPerView: 2,
                },
              },
            });
          });
        }
      }
    );
  }
});
